"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @format */
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const react_1 = require("react");
const colors_1 = require("../../../styles/colors");
const Typo_1 = require("../Typo/Typo");
/**
 * Primary UI component for user interaction
 */
const SimpleButton = (props) => {
    const { textUppercase } = props, rest = __rest(props, ["textUppercase"]);
    const [clicked, setClicked] = (0, react_1.useState)(false);
    let button;
    if (props.variant == 'icon-primary' ||
        props.variant == 'icon-secondary-dark-blue' ||
        props.variant === 'remove-red') {
        button = (0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({}, props, { children: props.children }));
    }
    else if (props.variant === 'favorite') {
        button = ((0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({}, props, { color: "inherit", onClick: (event) => {
                setClicked(!clicked);
                props.onClick && props.onClick(event);
            } }, { children: clicked ? ((0, jsx_runtime_1.jsx)(icons_material_1.StarRounded, { fontSize: props.size, htmlColor: colors_1.$yellow })) : ((0, jsx_runtime_1.jsx)(icons_material_1.StarOutlineRounded, { fontSize: props.size, htmlColor: colors_1.$grey20 })) })));
    }
    else {
        button = ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({}, rest, { children: (0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ textTransform: textUppercase ? 'uppercase' : 'none', variant: props.size === 'small' ? 'button' : 'buttonMedium' }, { children: props.children })) })));
    }
    return button;
};
exports.SimpleButton = SimpleButton;
